export default __webpack_public_path__ + "static/media/Damaso_No15_Closed2.74eb505c.jpg";